import BackBar from "components/ui/BackBar/BackBar";
import ContentContainer from "layout/Content/ContentContainer";
import { ReactComponent as IconNotification } from "assets/images/icons/notifications-sharp.svg";
import TitleWithIcon from "components/ui/TitleWithIcon/TitleWithIcon";
import Button from "components/ui/Button/Button";
import Trans from "features/translation/components/Trans";
import Radio from "components/form/Radio/Radio";
import useData from "hooks/useData";
import { useAccount } from "context/AccountContext";
import Alert from "components/ui/Alert/Alert";
import { useEffect, useState } from "react";
import Loader from "components/ui/Loader/Loader";
import { useLocation } from "react-router-dom";

function MyNotifications() {
  const { user } = useAccount();
  const location = useLocation();

  const [ isLoading, setIsLoading ] = useState(true);
  const { getData, patchData } = useData();

  const [ savedSettings, setSavedSettings ] = useState();
  const [ selectedBulletin, setSelectedBulletin ] = useState();
  const [ selectedGroupBulletin, setSelectedGroupBulletin ] = useState();
  const [ selectedMessage, setSelectedMessage ] = useState();
  const [ selectedSummary, setSelectedSummary ] = useState();
  const [ alert, setAlert ] = useState();

  const processStoredSettings = (data) => {
    setSavedSettings(data);
    setSelectedSummary(data?.field_notify_summary[0]?.value);
    setSelectedMessage(data?.field_notify_message[0]?.value);
    setSelectedBulletin(data?.field_notify_bulletin_comment[0]?.value);
    setSelectedGroupBulletin(data?.field_notify_group_bulletin[0]?.value || 'immediately');
  }

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        const { data } = await getData('rest/user/' + user?.id);

        processStoredSettings(data);

        setIsLoading(false);
      };

      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ location ]
  );

  const saveSettings = async (values) => {
    window.scrollTo(0, 0);
    setAlert();
    setIsLoading(true);

    values.uid = user.id;

    const result = await patchData(user.id, 'user', values);
    const data = await result.json();

    processStoredSettings(data);

    setIsLoading(false);

    if (result?.status === 200) {
      setAlert(<Alert message={ 'Uw instellingen zijn opgeslagen' } type={ 'success' }/>);
    } else {
      setAlert(<Alert message={ 'Uw instellingen konden niet worden opgeslagen' } type={ 'error' }/>);
    }
  }

  const handleSave = () => {
    saveSettings({
      'field_notify_message': selectedMessage,
      'field_notify_bulletin_comment': selectedBulletin,
      'field_notify_summary': selectedSummary,
      'field_notify_group_bulletin': selectedGroupBulletin,
    });
  }

  if (!isLoading && !savedSettings) {
    return <Alert message={ 'Er ging iets mis bij het ophalen van uw instellingen, probeer het later opnieuw.' }/>;
  }

  const notificationFrequencyMessage = [
    { id: 'immediately', value: 'Ja, direct' },
    { id: 'daily', value: 'Ja, samenvatting maximaal eens per dag' },
    { id: 'weekly', value: 'Ja, samenvatting maximaal eens per week' },
    { id: 'no', value: 'Nee' },
  ];

  const notificationFrequencySummary = [
    { id: 'weekly', value: 'Ja, maximaal eens per twee weken' },
    { id: 'no', value: 'Nee' },
  ];

  const notificationFrequencyBulletin = [
    { id: 'immediately', value: 'Ja, direct' },
    { id: 'daily', value: 'Ja, samenvatting maximaal eens per dag' },
    { id: 'weekly', value: 'Ja, samenvatting maximaal eens per week' },
    { id: 'no', value: 'Nee' },
  ];

  const notificationFrequencyGroupBulletin = [
    { id: 'immediately', value: 'Ja, direct' },
    { id: 'daily', value: 'Ja, samenvatting maximaal eens per dag' },
    { id: 'weekly', value: 'Ja, samenvatting maximaal eens per week' },
    { id: 'no', value: 'Nee' },
  ];

  return (
    <>
      <BackBar path={ `/startpagina` } containerWidth={ 'small' } label={ 'Naar startpagina' }/>

      <ContentContainer contentBackground={ true } contentGridType={ `small` } contentPadding={ true }>
        <TitleWithIcon title={ `Mijn meldingen` } hasBottomMargin={ true }>
          <IconNotification/>
        </TitleWithIcon>

        <h3><Trans
          text={ `Hoe vaak wilt u van ons e-mail ontvangen?` }/>
        </h3>

        { alert }

        {
          isLoading
            ?
            <Loader/>
            :
            <>
              <h5><Trans text={ `E-mail mij als ik een bericht in mijn berichtenbox ontvang` }/></h5>
              <div className={ 'margin-bottom-small' }>
                { notificationFrequencyMessage.map(item => <Radio key={ item.id }
                                                                  label={ item.value }
                                                                  checked={ item.id === selectedMessage }
                                                                  group={ 'message' }
                                                                  onChange={ () => setSelectedMessage(item.id) }/>) }
              </div>

              <h5><Trans
                text={ `E-mail mij als er nieuwe reacties zijn op mijn prikbordberichten of prikbordberichten waarop ik heb gereageerd` }/>
              </h5>
              <div className={ 'margin-bottom-small' }>
                { notificationFrequencyBulletin.map(item => <Radio key={ item.id }
                                                                   label={ item.value }
                                                                   checked={ item.id === selectedBulletin }
                                                                   group={ 'bulletin' }
                                                                   onChange={ () => setSelectedBulletin(item.id) }/>) }
              </div>

              <h5><Trans
                text={ `E-mail mij als er nieuwe groepsberichten worden geplaatst in mijn groepen` }/>
              </h5>
              <div className={ 'margin-bottom-small' }>
                { notificationFrequencyGroupBulletin.map(item => <Radio key={ item.id }
                                                                        label={ item.value }
                                                                        checked={ item.id === selectedGroupBulletin }
                                                                        group={ 'group-bulletin' }
                                                                        onChange={ () => setSelectedGroupBulletin(item.id) }/>) }
              </div>

              <h5><Trans
                text={ `E-mail mij met een samenvatting van nieuwe leden, activiteiten en prikbord onderwerpen op het platform` }/>
              </h5>
              <div className={ 'margin-bottom-small' }>
                {
                  notificationFrequencySummary.map(item => <Radio key={ item.id }
                                                                  label={ item.value }
                                                                  checked={ item.id === selectedSummary }
                                                                  group={ 'summary' }
                                                                  onChange={ () => setSelectedSummary(item.id) }/>)
                }
              </div>

              <Button variant={ 'secondary' } onClick={ handleSave }>
                Instellingen opslaan
              </Button>
            </>
        }
      </ContentContainer>
    </>
  );
}

export default MyNotifications;
